import { render, staticRenderFns } from "./PatientsAdmin.vue?vue&type=template&id=0db2da22&scoped=true"
import script from "./PatientsAdmin.vue?vue&type=script&lang=js"
export * from "./PatientsAdmin.vue?vue&type=script&lang=js"
import style0 from "./PatientsAdmin.vue?vue&type=style&index=0&id=0db2da22&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2da22",
  null
  
)

export default component.exports